import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { ChartLegendPosition } from "src/app/shared/models/enums/ChartLegendPosition.enum";
import { SalesSummary } from "src/app/shared/models/SalesSummary.model";

@Component({
	selector: "app-sales-guest-widget",
	templateUrl: "./sales-guest-widget.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class SalesGuestWidgetComponent implements OnInit, OnChanges {
	@Input() checkDate: string;
	@Output() checkDateChange = new EventEmitter<string>();

	@Input() currentDaySalesSummary: SalesSummary;
	@Output() currentDaySalesSummaryChange = new EventEmitter<SalesSummary>();

	@Input() salesGuestViewSelected: string;
	@Output() salesGuestViewSelectedChange = new EventEmitter<string>();

	sevenDaySalesChart = {
		options: undefined,
		data: undefined,
		type: "line",
	};

	sevenDayGuestChart = {
		options: undefined,
		data: undefined,
		type: "line",
	};

	sevenDayCheckAverageChart = {
		options: undefined,
		data: undefined,
		type: "line",
	};

	activeChart = {
		options: undefined,
		data: undefined,
		type: "line",
	};

	constructor(public app: AppService, public venueService: OOVenueService) {}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.salesGuestViewSelected) {
			this.activeChart.data = undefined;
			this.assignChart(changes.salesGuestViewSelected.currentValue);
		}
		if (changes.currentDaySalesSummary) {
			this.buildCharts();
		}
	}

	ngOnInit(): void {
		this.buildCharts();
		this.assignChart(this.salesGuestViewSelected);
	}

	async buildCharts() {
		this.buildSevenDaySalesChart();
		this.buildSevenDayGuestChart();
		this.buildSevenDayCheckAverageChart();
	}

	async assignChart(chartView: string) {
		switch (chartView) {
			case "sales":
				this.activeChart = { ...this.sevenDaySalesChart };
				break;
			case "guests":
				this.activeChart = { ...this.sevenDayGuestChart };
				break;
			case "checkAverage":
				this.activeChart = { ...this.sevenDayCheckAverageChart };
				break;
		}
	}

	async buildSevenDayGuestChart() {
		const data = {
			labels: this.currentDaySalesSummary.previousDaySales.map((i) => this.app.moment(i.checkDate, "MMDDYYYY").format("ddd M/D")),
			datasets: [
				{
					label: "Guest Check Average",
					data: this.currentDaySalesSummary.previousDaySales.map((i) => i.averageGuest),
					fill: true,
					borderColor: this.app.references.colorPallete.primary,
					backgroundColor: this.app.references.transparentize(this.app.references.colorPallete.primary, 0.75),
					yAxisID: "y",
					tension: 0.4,
				},
			],
		};
		this.sevenDayGuestChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
		this.sevenDayGuestChart.data = data;
	}

	async buildSevenDayCheckAverageChart() {
		const data = {
			labels: this.currentDaySalesSummary.previousDaySales.map((i) => this.app.moment(i.checkDate, "MMDDYYYY").format("ddd M/D")),
			datasets: [
				{
					label: "Sales",
					data: this.currentDaySalesSummary.previousDaySales.map((i) => i.averageCheck),
					fill: true,
					borderColor: this.app.references.colorPallete.primary,
					backgroundColor: this.app.references.transparentize(this.app.references.colorPallete.primary, 0.75),
					yAxisID: "y",
					tension: 0.4,
				},
			],
		};

		this.sevenDayCheckAverageChart.data = data;
		this.sevenDayCheckAverageChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
		this.sevenDayCheckAverageChart.options.scales = {
			y: {
				display: true,
			},
			x: {
				display: true,
			},
		};
	}

	async buildSevenDaySalesChart() {
		const data = {
			labels: this.currentDaySalesSummary.previousDaySales.map((i) => this.app.moment(i.checkDate, "MMDDYYYY").format("ddd M/D")),
			datasets: [
				{
					label: "Sales",
					data: this.currentDaySalesSummary.previousDaySales.map((i) => i.netSales),
					fill: true,
					borderColor: this.app.references.colorPallete.primary,
					backgroundColor: this.app.references.transparentize(this.app.references.colorPallete.primary, 0.75),
					yAxisID: "y",
					tension: 0.4,
				},
			],
		};

		this.sevenDaySalesChart.data = data;
		this.sevenDaySalesChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
		this.sevenDaySalesChart.options.scales = {
			y: {
				display: true,
			},
			x: {
				display: true,
			},
		};
	}
}
